(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8238],{

/***/ 13787:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telemedicine/categories",
      function () {
        return __webpack_require__(61286);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18138);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64952);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CustomBreadCrumbs = function(param) {
    var visible = param.visible, breadCrumbs = param.breadCrumbs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    var breadCrumbsWithHome = [
        {
            label: "홈",
            url: "/",
            logName: "home"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(breadCrumbs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumbsWithHome.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumbsWithHome.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomBreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_10__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 36576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qd": function() { return /* binding */ AccordionItem; },
/* harmony export */   "UQ": function() { return /* binding */ Accordion; },
/* harmony export */   "o4": function() { return /* binding */ AccordionTrigger; },
/* harmony export */   "vF": function() { return /* binding */ AccordionContent; }
/* harmony export */ });
/* unused harmony export useAccordionContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61536);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13029);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _utils_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76666);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10929);










var AccordionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var useAccordionContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AccordionContext);
    if (context === undefined) {
        throw new Error("useAccordionContext must be used within an AccordionProvider");
    }
    return context;
};
var AccordionProvider = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), initialMount = ref[0], setInitialMount = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setInitialMount(undefined);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionContext.Provider, {
        value: {
            initialMount: initialMount
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            children: children
        }))
    });
};
var Accordion = AccordionProvider;
var accordionVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_6__/* .cva */ .j)("typography-ui-17sb flex w-full items-center justify-between transition-all [&[data-state=open]>svg]:rotate-180", {
    variants: {
        variant: {
            default: "px-[12px] ",
            lg: "px-[24px]"
        },
        size: {
            default: "h-[56px]",
            sm: "h-[48px]",
            lg: "h-[64px]"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
var AccordionItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, _hasBorderBottom = _param.hasBorderBottom, hasBorderBottom = _hasBorderBottom === void 0 ? true : _hasBorderBottom, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "hasBorderBottom"
    ]);
    var initialMount = useAccordionContext().initialMount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Item */ .ck, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_7__.cn)("border-gray-50 border-t-0 border-r-0 border-b-[1px] border-l-0 border-solid", className, {
            "data-[state=closed]:[&>div]:hidden": initialMount !== undefined,
            "border-b-0": !hasBorderBottom
        })
    }, props));
});
AccordionItem.displayName = "AccordionItem";
var AccordionTrigger = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _size = _param.size, size = _size === void 0 ? "default" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "variant",
        "size"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Header */ .h4, {
        asChild: true,
        className: "flex items-center justify-between",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Trigger */ .xz, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            ref: ref,
            className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_7__.cn)(accordionVariants({
                variant: variant,
                size: size
            }), className)
        }, props), {
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: "h-4 w-4 shrink-0 transition-transform duration-200"
                })
            ]
        }))
    });
});
AccordionTrigger.displayName = _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Trigger.displayName */ .xz.displayName;
var AccordionContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var initialMount = useAccordionContext().initialMount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        forceMount: initialMount,
        className: "overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_7__.cn)("", className),
            children: children
        })
    }));
});
AccordionContent.displayName = _radix_ui_react_accordion__WEBPACK_IMPORTED_MODULE_3__/* .Content.displayName */ .VY.displayName;



/***/ }),

/***/ 61286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ categories; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/dn-design-system/components/ui/accordion.tsx
var accordion = __webpack_require__(36576);
// EXTERNAL MODULE: ./src/services/doctor/DiagnosisCategoryService.ts
var DiagnosisCategoryService = __webpack_require__(33310);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/templates/telemedicine/category/components/TreatmentCategoriesInfo.tsx





var TreatmentCategoriesInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "border-gray-50 border-t-0 border-r-0 border-b border-solid px-[24px] pt-[40px] pb-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "typography-ui-17sb text-gray-600",
                        children: "많이 찾는 증상"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-[20px] flex flex-wrap items-center gap-[8px]",
                        children: props.popularTreatmentCategories.map(function(category) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: common/* ROUTES.TELEMEDICINE.DOCTORS.buildPath */.Z6.TELEMEDICINE.DOCTORS.buildPath(DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment, category.id),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "typography-ui-15m text-gray-700",
                                            children: category.name
                                        })
                                    })
                                })
                            }, "popular-treatment-category-".concat(category.id));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* Accordion */.UQ, {
                    type: "multiple",
                    children: props.treatmentCategories.map(function(treatmentCategory) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion/* AccordionItem */.Qd, {
                            value: treatmentCategory.id,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* AccordionTrigger */.o4, {
                                    variant: "lg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center gap-[12px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: treatmentCategory.icon,
                                                alt: treatmentCategory.name,
                                                className: "aspect-square h-[32px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "typography-ui-17sb text-gray-600",
                                                children: treatmentCategory.name
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion/* AccordionContent */.vF, {
                                    children: treatmentCategory.treatments.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-wrap items-center gap-[8px] px-[24px] py-[20px]",
                                        children: treatmentCategory.treatments.map(function(treatment) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: common/* ROUTES.TELEMEDICINE.DOCTORS.buildPath */.Z6.TELEMEDICINE.DOCTORS.buildPath(DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment, treatment.id),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "typography-ui-15m text-gray-700",
                                                            children: treatment.name
                                                        })
                                                    })
                                                })
                                            }, "popular-treatment-category-".concat(treatment.id));
                                        })
                                    })
                                })
                            ]
                        }, "treatment-category-".concat(treatmentCategory.id));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_TreatmentCategoriesInfo = (TreatmentCategoriesInfo);

// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
;// CONCATENATED MODULE: ./src/components/templates/telemedicine/category/components/DepartmentCategoriesInfo.tsx




var DepartmentCategoriesInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "border-gray-50 border-t-0 border-r-0 border-b border-solid px-[24px] pt-[40px] pb-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "typography-ui-17sb text-gray-600",
                        children: "많이 찾는 과목"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-[20px] flex flex-wrap items-center gap-[8px]",
                        children: props.popularDepartmentCategories.map(function(category) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: common/* ROUTES.TELEMEDICINE.DOCTORS.buildPath */.Z6.TELEMEDICINE.DOCTORS.buildPath(DiagnosisCategoryService/* ECategoryType.Department */.qm.Department, category.id),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "typography-ui-15m text-gray-700",
                                            children: category.name
                                        })
                                    })
                                })
                            }, "popular-treatment-category-".concat(category.id));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-col",
                    children: props.departmentCategories.map(function(departmentCategory) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "border-gray-50 border-b-[1px] border-solid",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: common/* ROUTES.TELEMEDICINE.DOCTORS.buildPath */.Z6.TELEMEDICINE.DOCTORS.buildPath(DiagnosisCategoryService/* ECategoryType.Department */.qm.Department, departmentCategory.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "flex items-center justify-between p-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "typography-ui-17sb mb-[4px] text-gray-700",
                                                    children: departmentCategory.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "typography-ui-15r text-gray-400",
                                                    children: departmentCategory.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: departmentCategory.icon,
                                            alt: departmentCategory.name,
                                            className: "aspect-square w-[40px]"
                                        })
                                    ]
                                })
                            })
                        }, "treatment-category-".concat(departmentCategory.id));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_DepartmentCategoriesInfo = (DepartmentCategoriesInfo);

// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/components/templates/telemedicine/category/TelemedicineCategoriesTemplate.tsx











var renderSelectedCategoryType = function(selectedCategoryType, categoriesInfo) {
    if (selectedCategoryType === DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TreatmentCategoriesInfo, {
            popularTreatmentCategories: categoriesInfo.popularTreatmentCategories,
            treatmentCategories: categoriesInfo.treatmentCategories
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DepartmentCategoriesInfo, {
        departmentCategories: categoriesInfo.departmentCategories,
        popularDepartmentCategories: categoriesInfo.popularDepartmentCategories
    });
};
var TelemedicineCategoriesTemplate = function(props) {
    var client = props.client, viewModel = props.viewModel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            !client.isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                    breadCrumbs: viewModel.breadCrumbs,
                    visible: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "typography-ui-22sb flex h-[60px] items-center pr-[20px] pl-[24px] text-gray-900",
                        children: "증상/과목 선택"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex h-[44px] w-full items-center border-gray-50 border-b-[1px] border-solid px-[16px]",
                        children: viewModel.tabs.map(function(tab) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (0,style.cn)([
                                    "relative flex h-full flex-1 items-center",
                                    {
                                        'before:absolute before:bottom-0 before:left-[8px] before:h-[2px] before:w-[calc(100%-16px)] before:bg-gray-800 before:opacity-0 before:transition-opacity before:duration-300 before:content-[""]': true,
                                        "before:opacity-100": viewModel.selectedCategoryType === tab.type
                                    }, 
                                ]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path + (0,url/* addQueryString */.sC)({
                                        type: tab.type
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (0,style.cn)([
                                            "flex h-full w-full items-center justify-center",
                                            {
                                                "typography-ui-15sb text-gray-800": viewModel.selectedCategoryType === tab.type,
                                                "typography-ui-15m text-gray-400": viewModel.selectedCategoryType !== tab.type
                                            }, 
                                        ]),
                                        children: tab.label
                                    })
                                })
                            }, tab.label);
                        })
                    }),
                    renderSelectedCategoryType(viewModel.selectedCategoryType, viewModel.categoriesInfo)
                ]
            })
        ]
    });
};
/* harmony default export */ var category_TelemedicineCategoriesTemplate = (TelemedicineCategoriesTemplate);

// EXTERNAL MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts + 1 modules
var useGetDiagnosisCategories = __webpack_require__(60643);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/hooks/telemedicine/useTelemedicineCategoriesViewModel.ts




var tabs = [
    {
        type: DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment,
        label: "증상"
    },
    {
        type: DiagnosisCategoryService/* ECategoryType.Department */.qm.Department,
        label: "과목"
    }, 
];
var useTelemedicineCategoriesViewModel = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var selectedCategoryType = ((ref = router.query) === null || ref === void 0 ? void 0 : ref.type) || DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment;
    var categoriesInfo = (0,useGetDiagnosisCategories/* default */.Z)().categoriesInfo;
    var breadCrumbs = [
        {
            url: common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path,
            label: "비대면 진료",
            logName: "telemedicine_doctors"
        },
        {
            url: common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path,
            label: "증상/과목 선택",
            logName: "telemedicine_categories"
        }, 
    ];
    return {
        selectedCategoryType: selectedCategoryType,
        tabs: tabs,
        categoriesInfo: categoriesInfo,
        breadCrumbs: breadCrumbs
    };
};
/* harmony default export */ var telemedicine_useTelemedicineCategoriesViewModel = (useTelemedicineCategoriesViewModel);

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
;// CONCATENATED MODULE: ./src/pages/telemedicine/categories.tsx
// PageDescription: 비대면진료 증상과목 카테고리 페이지






var TelemedicineCategoriesPage = function(param) {
    var client = param.client;
    var viewModel = telemedicine_useTelemedicineCategoriesViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "비대면진료 예약\xb7약 처방받기 | 증상\xb7과목별 전화진료 - 닥터나우",
                description: "비대면진료가 필요할 때 닥터나우를 이용하면 병원에서 전화가 와요! 감기, 소아과, 탈모 등 다양한 분야의 진료와 약 처방이 가능해요.",
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path).concat((0,url/* addQueryString */.sC)({
                        type: viewModel.selectedCategoryType
                    }))
                },
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: "비대면진료, 비대면진료어플, 전화진료, 감기, 탈모, 소아과, 비대면약처방, 닥터나우"
                    }, 
                ],
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path).concat((0,url/* addQueryString */.sC)({
                    type: viewModel.selectedCategoryType
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(category_TelemedicineCategoriesTemplate, {
                client: client,
                viewModel: viewModel
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var categories = (TelemedicineCategoriesPage);


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7041,6492,9097,1498,209,8391,2271,6865,9774,2888,179], function() { return __webpack_exec__(13787); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);